import { FavoritesTypes } from './types';

const initialState = {
  favorites: {
    videos: []
  },
  loading: {
    fetchFavorites: false,
    addToFavorites: false,
    removeFromFavorites: false,
    reorderFavorites: false,
    favoritesPlayback: false
  },
  error: {
    fetchFavorites: null,
    addToFavorites: null,
    removeFromFavorites: null,
    reorderFavorites: null,
    favoritesPlayback: null
  },
  player: {
    videos: [],
    currentVideoIndex: 0,
    isPlaying: false,
    autoplayEnabled: true
  }
};

export const favoritesReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch favorites
    case FavoritesTypes.FETCH_FAVORITES_REQUEST:
      return {
        ...state,
        loading: {
          ...state.loading,
          fetchFavorites: true
        },
        error: {
          ...state.error,
          fetchFavorites: null
        }
      };
      
    case FavoritesTypes.FETCH_FAVORITES_SUCCESS:
      return {
        ...state,
        favorites: action.payload,
        loading: {
          ...state.loading,
          fetchFavorites: false
        }
      };
      
    case FavoritesTypes.FETCH_FAVORITES_FAILURE:
      return {
        ...state,
        loading: {
          ...state.loading,
          fetchFavorites: false
        },
        error: {
          ...state.error,
          fetchFavorites: action.payload
        }
      };
      
    // Add to favorites
    case FavoritesTypes.ADD_TO_FAVORITES_REQUEST:
      return {
        ...state,
        loading: {
          ...state.loading,
          addToFavorites: true
        },
        error: {
          ...state.error,
          addToFavorites: null
        }
      };
      
    case FavoritesTypes.ADD_TO_FAVORITES_SUCCESS:
      return {
        ...state,
        favorites: action.payload,
        loading: {
          ...state.loading,
          addToFavorites: false
        }
      };
      
    case FavoritesTypes.ADD_TO_FAVORITES_FAILURE:
      return {
        ...state,
        loading: {
          ...state.loading,
          addToFavorites: false
        },
        error: {
          ...state.error,
          addToFavorites: action.payload
        }
      };
    
    // Remove from favorites  
    case FavoritesTypes.REMOVE_FROM_FAVORITES_REQUEST:
      return {
        ...state,
        loading: {
          ...state.loading,
          removeFromFavorites: true
        },
        error: {
          ...state.error,
          removeFromFavorites: null
        }
      };
      
    case FavoritesTypes.REMOVE_FROM_FAVORITES_SUCCESS:
      return {
        ...state,
        favorites: action.payload,
        loading: {
          ...state.loading,
          removeFromFavorites: false
        }
      };
      
    case FavoritesTypes.REMOVE_FROM_FAVORITES_FAILURE:
      return {
        ...state,
        loading: {
          ...state.loading,
          removeFromFavorites: false
        },
        error: {
          ...state.error,
          removeFromFavorites: action.payload
        }
      };
      
    // Reorder favorites
    case FavoritesTypes.REORDER_FAVORITES_REQUEST:
      return {
        ...state,
        loading: {
          ...state.loading,
          reorderFavorites: true
        },
        error: {
          ...state.error,
          reorderFavorites: null
        }
      };
      
    case FavoritesTypes.REORDER_FAVORITES_SUCCESS:
      return {
        ...state,
        favorites: action.payload,
        loading: {
          ...state.loading,
          reorderFavorites: false
        }
      };
      
    case FavoritesTypes.REORDER_FAVORITES_FAILURE:
      return {
        ...state,
        loading: {
          ...state.loading,
          reorderFavorites: false
        },
        error: {
          ...state.error,
          reorderFavorites: action.payload
        }
      };
      
    // Player actions
    case FavoritesTypes.LOAD_FAVORITES_FOR_PLAYBACK_REQUEST:
      return {
        ...state,
        loading: {
          ...state.loading,
          favoritesPlayback: true
        },
        error: {
          ...state.error,
          favoritesPlayback: null
        }
      };
      
    case FavoritesTypes.LOAD_FAVORITES_FOR_PLAYBACK_SUCCESS:
      return {
        ...state,
        loading: {
          ...state.loading,
          favoritesPlayback: false
        },
        player: {
          ...state.player,
          videos: action.payload.videos,
          currentVideoIndex: action.payload.startIndex || 0,
          isPlaying: true
        }
      };
      
    case FavoritesTypes.LOAD_FAVORITES_FOR_PLAYBACK_FAILURE:
      return {
        ...state,
        loading: {
          ...state.loading,
          favoritesPlayback: false
        },
        error: {
          ...state.error,
          favoritesPlayback: action.payload
        }
      };
      
    case FavoritesTypes.SET_FAVORITES_PLAYBACK_INDEX:
      return {
        ...state,
        player: {
          ...state.player,
          currentVideoIndex: action.payload
        }
      };
      
    case FavoritesTypes.NEXT_FAVORITES_VIDEO:
      return {
        ...state,
        player: {
          ...state.player,
          currentVideoIndex: Math.min(
            state.player.currentVideoIndex + 1,
            state.player.videos.length - 1
          )
        }
      };
      
    case FavoritesTypes.PREVIOUS_FAVORITES_VIDEO:
      return {
        ...state,
        player: {
          ...state.player,
          currentVideoIndex: Math.max(0, state.player.currentVideoIndex - 1)
        }
      };
      
    case FavoritesTypes.TOGGLE_FAVORITES_AUTOPLAY:
      return {
        ...state,
        player: {
          ...state.player,
          autoplayEnabled: action.payload
        }
      };
      
    case FavoritesTypes.CLEAR_FAVORITES_PLAYBACK:
      return {
        ...state,
        player: {
          ...initialState.player
        }
      };
      
    default:
      return state;
  }
};
